import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getDatasets, getEntitlements, getTabs } from "./selectors"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    tokenId: props.params.tokenId,
    role: getRole(state),
  }),
  required: ["account", "tokenId"],
  data: [{
    resource: "token",
    url: ({ tokenId }) => ({
      id: `token-${tokenId}`,
      query: `query($tokenId: Id!) {
          token(id: $tokenId) {
            name
            teams{
              alias
            }
          }
        }`,
      variables: {
        tokenId,
      },
    }),
  },
  {
    resource: "tokenDatasetEntitlements",
    passthrough: true,
    url: ({ account, tokenId }) => `/api/${account}/reports/entitlements/token/${tokenId}`,
  }, {
    resource: "adminDatasets",
    url: ({ role, account }) => role === "admin" ? `/api/${account}/datasets` : null,
  }],
  mapStateToProps: (state, props) => ({
    userId: get(state, "user.id"),
    datasets: getDatasets(state),
    entitlements: getEntitlements(state),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
